import { render, staticRenderFns } from "./EditTaxModal.vue?vue&type=template&id=2113f990&scoped=true"
import script from "./EditTaxModal.vue?vue&type=script&lang=js"
export * from "./EditTaxModal.vue?vue&type=script&lang=js"
import style0 from "./EditTaxModal.vue?vue&type=style&index=0&id=2113f990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113f990",
  null
  
)

export default component.exports